import { testAll } from './date-tests';
import { toClassName } from './utils/object';
import { isAfter, isBefore, isToday, isSameMonth } from 'date-fns';

let defaults = {
	today: isToday,
	hidden: false,
	outside: false,
	disabled: false,
	selected: false,
};

export function getModifiers(date, month, config) {
	let modifiers = { ...defaults, ...config.modifiers };

	modifiers.disabled = [
		date => isAfter(date, config.maxDate),
		date => isBefore(date, config.minDate),
	];

	modifiers.outside = !isSameMonth(date, month);
	modifiers.hidden = modifiers.outside && !config.showOutsideDays;

	for (let [key, value] of Object.entries(modifiers)) {
		let { matches, isStart, isEnd } = testAll(date, value);

		modifiers[key] = matches;

		if (isEnd) {
			modifiers[key + 'End'] = true;
		}

		if (isStart) {
			modifiers[key + 'Start'] = true;
		}
	}

	return modifiers;
}

export function getClasses(modifiers, classNames) {
	let classes = [ classNames.day ];

	for (let [key, value] of Object.entries(modifiers)) {
		if (!value) {
			continue;
		}

		if (Object.prototype.hasOwnProperty.call(classNames, key)) {
			classes.push(classNames[key]);
		} else {
			classes.push(toClassName(key));
		}
	}

	return classes;
}
